import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import DesignvendorDashboard from '../DesignvendorDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function DesignvendorPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < DesignvendorDashboard />
    )

}